// src/utils/googleTranslateFix.ts

let isPatched = false;

const applyPatch = () => {
  if (isPatched) return;
  isPatched = true;

  console.info(
    '%c[Google Translate Fix] Patch activated - DOM methods patched to prevent React crashes',
    'color: #4CAF50; font-weight: bold'
  );

  const originalRemoveChild = Node.prototype.removeChild;
  // @ts-expect-error - Monkey patching DOM methods
  Node.prototype.removeChild = function (child: Node) {
    if (child.parentNode !== this) {
      console.warn('[Google Translate Fix] removeChild blocked - node not a child');
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  // @ts-expect-error - Monkey patching DOM methods
  Node.prototype.insertBefore = function (newNode: Node, referenceNode: Node | null) {
    if (referenceNode && referenceNode.parentNode !== this) {
      console.warn('[Google Translate Fix] insertBefore blocked - reference node not a child');
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
};

const isTranslated = () => {
  const html = document.documentElement;
  return html.classList.contains('translated-ltr') || html.classList.contains('translated-rtl');
};

export const setupGoogleTranslateFix = () => {
  // Check if already translated on page load
  if (isTranslated()) {
    applyPatch();
    return;
  }

  // Watch for translation activation
  const observer = new MutationObserver(() => {
    if (isTranslated()) {
      applyPatch();
      observer.disconnect();
    }
  });

  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'lang'],
  });

  console.debug('[Google Translate Fix] Observer set up - waiting for translation activation');
};
